module.exports = __webpack_public_path__ + "static/media/HAUX_NUTRICAO_9.8c894aba.pdf";